// Approved DCC client testimonials — ONE shared data source for every place a
// testimonial card appears on the website. Each field (photo, name, designation,
// organisation, quote) is separately editable per card.
//
// To replace a person (e.g. Vijay Dudhatra): edit ONLY that entry's fields and
// supply a quote approved for the replacement person — never re-attribute an
// existing quote to a new name.
export const TESTIMONIALS = [
  {
    "order": 1,
    "name": "Syed Shamshuddin",
    "theme": "PROFESSIONAL EXECUTION",
    "designation": "Chief Engineer",
    "organisation": "Great Destinations Hotels & Resorts, Bangalore",
    "quote": "DCC handled the appointed scope with precision and professionalism. The team brought strong technical expertise in kitchen and air-duct cleaning and delivered a practical, economical solution tailored to our facility.",
    "photoSrc": "/assets/testimonials/01_syed_shamshuddin.webp"
  },
  {
    "order": 2,
    "name": "Navaneethan R",
    "theme": "LONG TERM RELATIONSHIP",
    "designation": "Chief Engineer",
    "organisation": "Hilton Manyata Bengaluru",
    "quote": "I have worked with the DCC team for three years. The team is professional, focused on customers and committed to completing the job. Its dedication and expertise have been impressive.",
    "photoSrc": "/assets/testimonials/02_navaneethan_r.webp"
  },
  {
    "order": 3,
    "name": "Sonaram Choudhary",
    "theme": "DOCUMENTED COMPLETION",
    "designation": "Chief Engineer",
    "organisation": "Hilton Garden Inn Goa Calangute",
    "quote": "DCC completed our kitchen-exhaust cleaning professionally and on schedule. The team was punctual, competitively priced and provided a detailed before-and-after report with the required service documentation.",
    "photoSrc": "/assets/testimonials/03_sonaram_choudhary.webp"
  },
  {
    "order": 4,
    "name": "Mahadev Ghulnawar",
    "theme": "RESPONSIVE DELIVERY",
    "designation": "Director of Engineering",
    "organisation": "Hyatt Regency Kolkata",
    "quote": "Prompt response, knowledgeable and skilled team, and work completed on time with high standards and efficiency.",
    "photoSrc": "/assets/testimonials/03_mahadev_ghulnawar.webp"
  },
  {
    "order": 5,
    "name": "Jamiroddin Kazi",
    "theme": "BEFORE AND AFTER",
    "designation": "Director of Engineering",
    "organisation": "Sheraton Hyderabad",
    "quote": "Punctual, professional and competitively priced, with detailed before-and-after presentation and necessary certifications.",
    "photoSrc": "/assets/testimonials/04_jamiroddin_kazi.webp"
  },
  {
    "order": 6,
    "name": "Shubham Awasthi",
    "theme": "PEER RECOMMENDED",
    "designation": "Director of Engineering",
    "organisation": "Le Meridien Goa",
    "quote": "I heard about DCC at the engineers forum. The team is responsive and amazing to work with.",
    "photoSrc": "/assets/testimonials/05_shubham_awasthi.webp"
  }
];
